<template>
  <main>
    <warehouse-list :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('warehouse.settings.title') }}
        </el-col>
      </el-row>

      <el-row class="bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('warehouse.settings.subtitleTodaySettings') }}
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end" v-show="!warehouse.isEditingTodaySettings">
              <el-button
                id="btn-edit-warehouse-today-settings"
                plain
                @click="editTodayWarehouseSettings"
                size="mini"
                v-if="showEditWarehouseSettingsButton"
                class="button-action-default"
              >{{ $t('warehouse.settings.edit') }}</el-button>
              <start-day />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <today-settings ref="today-settings"/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('warehouse.settings.subtitle') }}
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <el-button
                  id="btn-edit-warehouse-settings"
                  plain
                  @click="editWarehouseSettings"
                  size="mini"
                  v-if="showEditWarehouseSettingsButton"
                  v-show="!warehouse.isEditingSettings"
                  class="button-action-default"
                >{{ $t('warehouse.settings.edit') }}</el-button>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <general-settings ref="general-settings" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('warehouse.settings.subtitleSchedule') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <schedule-settings ref="scheduleSettings"/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import WarehouseList from '@/components/WarehouseList/WarehouseList';
import GeneralSettings from './GeneralSettings';
import ScheduleSettings from './ScheduleSettings';
import TodaySettings from './TodaySettings';
import StartDay from './components/StartDay';

export default {
  name: 'settings',
  components: {
    WarehouseList,
    GeneralSettings,
    ScheduleSettings,
    TodaySettings,
    StartDay
  },
  data() {
    return {
      actionSelectChained: ['warehouse/getWarehouseDetail', ['warehouse/setEditingSettings', false], ['warehouse/setEditingTodaySettings', false]]
    };
  },
  computed: {
    ...mapGetters(['user', 'warehouse']),
    showEditWarehouseSettingsButton() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_SETTINGS);
    }
  },
  methods: {
    editWarehouseSettings() {
      this.$refs['general-settings'].resetForm();
      this.$store.dispatch('warehouse/setEditingSettings', true);
    },
    editTodayWarehouseSettings() {
      this.$refs['today-settings'].resetForm();
      this.$store.dispatch('warehouse/setEditingTodaySettings', true);
    },
    handleRefresh() {
      this.$refs.scheduleSettings.getWarehouseDetail();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .reverse-form-actions {
    margin-bottom: 18px;
  }

  #btn-edit-warehouse-today-settings {
    margin-right: 10px;
  }
</style>
